<template>
  <InfoTooltip text="Podrobné informácie o krytí nájdete na " :link="link" linkText="Informácie o poistení"/>
</template>

<script>
import InfoTooltip from "@/components/InfoTooltip.vue";

export default {
  name: "PdfInfoTooltip",
  components: {InfoTooltip},
  props: {
    link: {
      type: String,
      required: true,
    },
  },
};
</script>
